<template>
  <div class="content-page">
    <top-bar :topbarList="topbarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";
export default {
  data() {
    return {};
  },
  components: {
    topBar,
  },
  computed: {
    topbarList() {
      let topbarList = [
        {
          name: "基础设置",
          isActive: false,
          path: "/setting/freshDistribution/base",
        },
        {
          name: "配送时间",
          isActive: false,
          path: "/setting/freshDistribution/time",
        },
        {
          name: "提货点",
          isActive: false,
          path: "/setting/freshDistribution/pickUpPoint",
        },
      ];
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
        if (val.childrenPath) {
          if (~val.childrenPath.indexOf(this.$route.path)) {
            val.isActive = true;
          }
        }
      });
      return topbarList;
    },
  },
};
</script>
